import XhrRequestHandler from '../../lib/XhrRequestHandler';
import { Club, ClubJSON, DetalleJugadores, DetalleJugadoresPorRamaJSON } from './Club';
export class ClubSystem {
  private readonly base = '/clubs';
  constructor(private requestHandler: XhrRequestHandler) {}

  async getClubIdentifiedBy(id: string): Promise<Club> {
    const data = await this.requestHandler.get<ClubJSON>(`${this.base}/${id}`);
    return Club.fromJSON(data);
  }

  async getList(): Promise<Club[]> {
    const data = await this.requestHandler.get<ClubJSON[]>(`${this.base}`);
    console.log(data);
    return data.map((entity) => Club.fromJSON(entity));
  }

  async getListForDropdown(): Promise<Club[]> {
    const data = await this.requestHandler.get<ClubJSON[]>(`${this.base}/for-dropdown`);
    console.log(data);
    return data.map((entity) => Club.fromJSON(entity));
  }

  async getDetalleJugadores(cid: string, tid: string): Promise<DetalleJugadoresPorRamaJSON[]> {
    const data = await this.requestHandler.get<DetalleJugadoresPorRamaJSON[]>(
      `${this.base}/detalle-jugadores?club_id=${cid}&tem_id=${tid}`
    );
    return data;
  }

  async save(entity: Club) {
    const data = entity.toJSON();
    const savedEntity = await this.requestHandler.post<ClubJSON, ClubJSON>(this.base, data);
    return Club.fromJSON(savedEntity);
  }

  getBaseUrlForDatagrid() {
    return this.requestHandler.requestUrl(`${this.base}/datagrid`);
  }

  getUrlForImage(image: string) {
    return this.requestHandler.requestUrl(`/uploads/images/federacion/${image}`);
  }

  async getClubByJugadorId(id: string): Promise<Club> {
    const data = await this.requestHandler.get<ClubJSON>(`${this.base}/of-jugador/${id}`);
    return Club.fromJSON(data);
  }

  async getClubesDisponibles(divisionId: string): Promise<Club[]> {
    const params = '?div_id=' + divisionId;
    const data = await this.requestHandler.get<ClubJSON[]>(`${this.base}/equipos-disponibles${params}`);
    return data.map((entity) => Club.fromJSON(entity));
  }

  async getClubesFedId(fedId: string): Promise<Club[]> {
    // const params = '?fed_id=' + fedId;
    const data = await this.requestHandler.get<ClubJSON[]>(`${this.base}/clubesByFed/${fedId}`);
    return data.map((entity) => Club.fromJSON(entity));
  }

  /**
   *
   * @param id
   * @returns CUIDADO! Este metodo ignora el control de acceso
   */
  async getClubById(id: string): Promise<Club> {
    const data = await this.requestHandler.get<ClubJSON>(`${this.base}/by-id/${id}`);
    return Club.fromJSON(data);
  }
}
